import * as gateway from 'sfx-web-contract';
import { AlkLogger } from '@alk/core';
import { ISettings, SerializedRecord, SETTINGS_KEYS } from '../../../interfaces';
import { ISettingsPartialRecord } from '.';

export function decodeUserSettings(data: Uint8Array): ISettingsPartialRecord {

    try {
        const response = gateway.UserSettingsResponse.decode(data);

        return SETTINGS_KEYS.reduce(
            (accObj, curKey) => {
                const value = response.Items[ curKey ];
                return Boolean(value) ? { ...accObj, ...{ [ curKey ]: value } } : accObj;
            }
            , {} as ISettingsPartialRecord,
        );

    } catch (error) {
        AlkLogger.error(`[PersistenceAdapterService#decode] Decoding error ${ data } not decode to UserSettingsResponse message`);
        throw error;
    }
}

export function removeUndefinedSettings(changedSettings: Partial<SerializedRecord<ISettings>>) : Partial<SerializedRecord<ISettings>> {
    return  Object.keys(changedSettings).reduce((acc, key) => {
        if (changedSettings[ key ] !== undefined) {
            acc[ key ] = changedSettings[ key ];
        }
        return acc;
    }, {});
}
